export default __webpack_public_path__ + "static/media/classplus-leaders.409e0881.png";